import React from 'react';
import { HeroSection } from './components/HeroSection';
import { RecipeCountSection } from './components/RecipeCountSection';
import { SnackWarningSection } from './components/SnackWarningSection';
import { PainPointsSection } from './components/PainPointsSection';
import { BenefitsRowSection } from './components/BenefitsRowSection';
import { ProductRevealSection } from './components/ProductRevealSection';
import { BonusGridSection } from './components/BonusGridSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { MoreThan200Section } from './components/MoreThan200Section';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-[#c4f000] selection:text-[#1f2e10]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <RecipeCountSection data-id="element-2" />
      <SnackWarningSection data-id="element-3" />
      <PainPointsSection data-id="element-4" />
      <BenefitsRowSection data-id="element-5" />
      <ProductRevealSection data-id="element-6" />
      <BonusGridSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <MoreThan200Section data-id="element-9" />
      <PricingSection data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <FinalCTASection data-id="element-13" />
    </div>;
}